import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import NavigationItem from 'af-components/Header/ScheduleBoardNavigation/NavigationItem';

import EquipmentSection from './EquipmentSection';
import LaborSection from './LaborSection';
import OfficeInfo from '../../Shared/Header/OfficeInfo';

type OwnProps = {
	dueDate: string;
	showOfficeInfo: boolean;
};

type Props = OwnProps;

const Toolbar: React.FC<Props> = (props: Props) => {
	const { dueDate, showOfficeInfo } = props;

	return (
		<>
			<div className="display-view-header">
				<span className="display-view-header-title">{TimeUtils.formatDate(dueDate, TimeFormat.SB_DATE_LONG)}</span>
				<div className="display-view-statistics-wrapper">
					{showOfficeInfo && <OfficeInfo dueDate={dueDate} />}
				</div>
				<div className="display-view-header-navigation">
					<NavigationItem />
				</div>
			</div>
			<div className="display-view-toolbar">
				<LaborSection dueDate={dueDate} />
				<EquipmentSection dueDate={dueDate} />
			</div>
		</>
	);
};

export default React.memo(Toolbar);
